import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/serviceOrderTemplatesActions'
import * as api from '../../api/template'

function* getServiceOrderTemplates(action) {
  try {
    const payload = yield call(api.getServiceOrderTemplatesList)
    yield put({ type: constants.GET_SERVICE_ORDER_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SERVICE_ORDER_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetServiceOrderTemplates() {
  yield takeLatest(constants.GET_SERVICE_ORDER_TEMPLATES.ACTION, getServiceOrderTemplates)
}

function* getServiceOrderTemplateItems(action) {
  try {
    const payload = yield call(api.getServiceOrderTemplatesItems, action.serviceOrderId)
    yield put({ type: constants.GET_SERVICE_ORDER_TEMPLATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SERVICE_ORDER_TEMPLATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateItems() {
  yield takeLatest(constants.GET_SERVICE_ORDER_TEMPLATE_ITEMS.ACTION, getServiceOrderTemplateItems)
}

export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchGetServiceOrderTemplates), fork(watchGetTemplateItems)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/serviceOrderTemplateSaga.js